import { useQuery } from '@tanstack/react-query'
import { getVisibility } from '@/lib/api/visibility'

/** Product Visibility data (Screen 5). Server pre-sorts divergent-first; we render in that order. */
export function useVisibility() {
  return useQuery({
    queryKey: ['visibility'],
    queryFn: getVisibility,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  })
}
